/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/1/22
 */

import React from "react";
import {FormControl} from "@mui/material";
import EmployeesControl from "../../controls/EmployeesControl";

export interface EmployeeFilterControlProps {
	label: string
	values: string[]
	attribute: string
	onChange: (filter: Record<string, any>) => void
	onClear: (attributes: string[]) => void
}

export default function EmployeeFilterControl(props: EmployeeFilterControlProps) {

	return (
		<FormControl fullWidth variant={"standard"}>
			<EmployeesControl
				label={props.label}
				values={props.values}
				onChange={(ids) => {
					if (ids.length > 0) props.onChange({ [props.attribute]: ids });
					else props.onClear([props.attribute]);
				}}
			/>
		</FormControl>
	);

}